import axios from 'axios';
import store  from '../store';

const SupplierSurveyService = {
  getSupplierSurveys (service) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_NONCACHE}/surveys/admin/supplier_surveys/form.json?supplier_id=${store.state.customer.supplier.id}&service=${service}`
    });
  },
  getSupplierSurveysHideRate (service) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_NONCACHE}/surveys/admin/supplier_surveys/detail_supplier_surveys.json?supplier_id=${store.state.customer.supplier.id}&service=${service}`,
    });
  }
}

export { SupplierSurveyService }